import { Box, Container, RowItem, Rows, Text, TextLevels } from '@bytel/trilogy-react-ts';
import { VictoryLabel, VictoryPie } from 'victory';
import { RingChartProps } from './type';

const pieStyle = {
  labels: {
    fontSize: 18,
    fill: '#00263C',
  },
};

const getLighterColor = (hex: string): string => {
  // Convertir hex en RGB
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  // Augmenter la luminosité de 40%
  const lighter = (c: number) => Math.min(255, Math.round(c + (255 - c) * 0.4));

  // Reconvertir en hex
  const toHex = (c: number) => c.toString(16).padStart(2, '0');
  return `#${toHex(lighter(r))}${toHex(lighter(g))}${toHex(lighter(b))}`;
};

const RingChart: React.FC<RingChartProps> = ({ title, valueList, total, centerText, onClick }: RingChartProps) => {
  return (
    <Box className="is-fullwidth is-fullheight" data-cy="ring-chart-box">
      <Container className="is-fullwidth is-fullheight">
        <Rows className="has-background-white">
          <RowItem>
            <Text level={TextLevels.ONE} className="has-text-weight-bold has-text-centered is-marginless">
              {title}
            </Text>
          </RowItem>
          <svg
            viewBox="-150 -150 800 800"
            preserveAspectRatio="xMidYMid meet"
            style={{ width: '100%', height: '100%' }}
          >
            <VictoryPie
              standalone={false}
              width={500}
              height={500}
              innerRadius={140}
              radius={240}
              labelRadius={280}
              data={valueList}
              x="label"
              y="percentage"
              style={pieStyle}
              colorScale={valueList.map((v) => v.fill)}
              labels={({ datum }) => `${datum.label}`}
              events={[
                {
                  target: 'data',
                  eventHandlers: {
                    onClick: (evt) => {
                      evt.preventDefault();
                      return [
                        {
                          target: 'data',
                          mutation: (props) => {
                            if (onClick) onClick(props.index);
                          },
                        },
                      ];
                    },
                    onMouseOver: () => {
                      return [
                        {
                          target: 'data',
                          mutation: (props) => {
                            const lighterColor = getLighterColor(valueList[props.index]?.fill || '#C4C4C4');
                            return {
                              style: { ...props.style, fill: lighterColor, cursor: 'pointer' },
                            };
                          },
                        },
                      ];
                    },
                    onMouseOut: () => {
                      return [
                        {
                          target: 'data',
                          mutation: () => ({
                            style: undefined,
                          }),
                        },
                      ];
                    },
                  },
                },
              ]}
            />
            <VictoryLabel
              textAnchor="middle"
              style={{ fontSize: 28 }}
              x={250}
              y={250}
              text={centerText ?? `${total}\n Total`}
            />
          </svg>
        </Rows>
      </Container>
    </Box>
  );
};
export default RingChart;
